import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5550/api/v1/', // replace with your API URL
});

// Request interceptor to add token to headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Or however you store the token
    const language = 'he'; //en
    // const lang = localStorage.getItem('i18nextLng'); // Or however you store the token

    // Do not add token for login endpoint
    if (!config.url.includes('/login') && token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['accept-language'] = `${language}`;
    // Add the lang parameter to the request URL
    // if (lang) {
    //   const url = new URL(config.url, config.baseURL); // Handle relative URLs
    //   url.searchParams.set('lang', lang);
    //   config.url = url.toString();
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 400 || status === 401 || status === 500) {
        const alertEvent = new CustomEvent('alertEvent', {
          detail: {
            message: 'Bad Request',
            errorResponse: error.response.data,
          },
        });
        document.dispatchEvent(alertEvent);

        if (error.response.data.errors) {
          error.response.data.errors.forEach((err) => {
            const alertEvent = new CustomEvent('alertEvent', {
              detail: {
                message: err.message,
                severity: 'error',
              },
            });
            document.dispatchEvent(alertEvent);
          });
        }
      }

      if (status === 401 || status === 403) {
        console.log('error.response.data', error.response.data);
        const code = error?.response?.data?.code;

        //=== check for invalid token and logout ===//
        if (code === 'TOKEN_INVALID') {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }

        const alertEvent = new CustomEvent('alertEvent', {
          detail: {
            message: 'Unauthorized',
            redirect: '/login',
            errorResponse: error.response.data,
          },
        });
        document.dispatchEvent(alertEvent);
        // setTimeout(() => {
        //   localStorage.removeItem('token');
        //   window.location.href = '/login'; // Add redirection here
        // }, 1000);
      }

      if (status === 500) {
        const alertEvent = new CustomEvent('alertEvent', {
          detail: {
            message: 'Server Error',
            errorResponse: error.response.data,
          },
        });
        document.dispatchEvent(alertEvent);
      }
      if (status === 4030) {
        const alertEvent = new CustomEvent('alertEvent', {
          detail: {
            message: 'Server Error',
            errorResponse: error.response.data,
          },
        });
        document.dispatchEvent(alertEvent);
      }
    }

    // Ensure error is propagated to the caller (mutation hook, etc.)
    return Promise.reject(error);
  },
);

export default axiosInstance;
